const BOARD_ISSUE_ENDPOINT = "/wp-json/wagedwar/v1/board-issue";
const reportedBoardIssues = new Set();

const getHiddenInputValue = (id) => {
  if (typeof document === "undefined") {
    return "";
  }

  return document.getElementById(id)?.value || "";
};

const getConnectionInfo = () => {
  if (typeof navigator === "undefined" || !navigator.connection) {
    return null;
  }

  return {
    effectiveType: navigator.connection.effectiveType,
    downlink: navigator.connection.downlink,
    rtt: navigator.connection.rtt,
  };
};

const getResponseKind = (value) => {
  if (Array.isArray(value)) {
    return "array";
  }

  if (value === null) {
    return "null";
  }

  return typeof value;
};

const getDedupeKey = (stage, details) => [
  stage,
  details?.sport || "",
  details?.stat || "",
  details?.gameId || details?.game_id || "",
  details?.status || "",
  details?.url || "",
  details?.message || "",
].join("|");

export function reportBoardIssue(stage, details = {}) {
  if (typeof window === "undefined" || typeof fetch !== "function") {
    return Promise.resolve(false);
  }

  const dedupeKey = getDedupeKey(stage, details);
  if (reportedBoardIssues.has(dedupeKey)) {
    return Promise.resolve(false);
  }

  if (reportedBoardIssues.size > 30) {
    reportedBoardIssues.clear();
  }
  reportedBoardIssues.add(dedupeKey);

  const payload = {
    issue: "board_load",
    stage,
    shrk: details.shrk ?? getHiddenInputValue("shrk"),
    uid: details.uid ?? getHiddenInputValue("uid"),
    page: window.location.href,
    host: window.location.host,
    path: window.location.pathname,
    ts: new Date().toISOString(),
    visibilityState: typeof document !== "undefined" ? document.visibilityState : "",
    connection: getConnectionInfo(),
    responseKind: details.responseKind || getResponseKind(details.response),
    ...details,
  };

  delete payload.response;

  let body;
  try {
    body = JSON.stringify(payload);
  } catch (error) {
    return Promise.resolve(false);
  }

  return fetch(BOARD_ISSUE_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    cache: "no-store",
    keepalive: body.length < 60000,
  }).catch(() => false);
}

export default reportBoardIssue;
